import React, { createContext, useContext, useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import { TABLES } from '../lib/constants';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [originalAdmin, setOriginalAdmin] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const storedUser = localStorage.getItem('rox_user');
    const storedAdmin = localStorage.getItem('rox_admin_orig');
    if (storedUser) setUser(JSON.parse(storedUser));
    if (storedAdmin) setOriginalAdmin(JSON.parse(storedAdmin));
  }, []);

  const login = async (username) => {
    setLoading(true);
    setError('');
    try {
      const { data, error: apiError } = await supabase
        .from(TABLES.USERS)
        .select('*')
        .eq('username', username)
        .single();

      if (apiError || !data) throw new Error('User not found');
      setUser(data);
      localStorage.setItem('rox_user', JSON.stringify(data));
      return data;
    } catch (err) {
      setError(err.message);
      return null;
    } finally {
      setLoading(false);
    }
  };

  const updateLocalUser = (updatedUser) => {
    setUser(updatedUser);
    localStorage.setItem('rox_user', JSON.stringify(updatedUser));
  };

  const impersonate = (targetUser) => {
    if (user?.role === 'super_admin' && !originalAdmin) {
      setOriginalAdmin(user);
      localStorage.setItem('rox_admin_orig', JSON.stringify(user));
    }
    setUser(targetUser);
    localStorage.setItem('rox_user', JSON.stringify(targetUser));
  };

  const stopImpersonating = () => {
    if (originalAdmin) {
      setUser(originalAdmin);
      localStorage.setItem('rox_user', JSON.stringify(originalAdmin));
      setOriginalAdmin(null);
      localStorage.removeItem('rox_admin_orig');
    }
  };

  const logout = () => {
    setUser(null);
    setOriginalAdmin(null);
    localStorage.removeItem('rox_user');
    localStorage.removeItem('rox_admin_orig');
  };

  return (
    <AuthContext.Provider value={{ user, originalAdmin, login, logout, impersonate, stopImpersonating, updateLocalUser, loading, error }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);